import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { omit, isNil } from 'ramda';

import { initialValues } from '../../../forms/cashback/editForm';
import DatePresenter from '../../../presenters/DatePresenter';
import StorePresenter from '../../../presenters/StorePresenter';
import CashbackPresenter from '../../../presenters/CashbackPresenter';
import FormHeader from '../../../components/FormHeader';
import Flash from '../../../components/forms/Flash';
import EditCashbackFormFields from '../../../components/FastCash/EditCashbackFormFields';
import { StoreProvider } from '../../../components';
import { updateCashback } from '../../../mutations';

const CashbackEditView = (props) => {
  const { lists, relay, history, cashback } = props;
  const [cashbackParams, setCashbackParams] = useState(cashback);
  const [errors, setErrors] = useState(null);
  const stores = lists.stores.edges.map((e) => e.node);
  const handleCasbhackParamsUpdate = ({ target }) => {
    const { id, value } = target;

    setCashbackParams({ ...cashbackParams, [id]: value });
  };

  const handleDateUpdate = (newDate) => {
    setCashbackParams({
      ...cashbackParams,
      date: DatePresenter.shortFormattedDate(newDate),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const paramValues = Object.values(cashbackParams);
    if (paramValues.includes(null))
      return setErrors({ error: 'All fields must be present' });
    const defaultParams = {
      afterDate: DatePresenter.oneMonthAgo(),
      beforeDate: DatePresenter.today(),
      byAuth0Id: '',
      stateEq: '',
      bankAccountIdEq: '',
    };

    const params = omit(['rate', 'amount'], cashbackParams);

    const paramsToSend = { ...defaultParams, ...params };

    return updateCashback(relay.environment, paramsToSend, {
      onCompleted: handleSubmitSuccess,
    });
  };

  const handleSubmitSuccess = ({ updateCashback }) => {
    const { errors, errorMessage } = updateCashback;
    if (errors) return setErrors(errors);
    if (errorMessage) return setErrors({ error: errorMessage });

    history.goBack();
  };

  return (
    <div className="cashbacks">
      <form className="create-cashback-form" onSubmit={handleSubmit}>
        <FormHeader title="Edit cashback">
          <input id="saveCashback" type="submit" defaultValue="Save" />
        </FormHeader>
        {!isNil(errors) && <Flash response={errors} />}
        <EditCashbackFormFields
          cashbackParams={cashbackParams}
          stores={stores}
          onChange={handleCasbhackParamsUpdate}
          onDateChange={handleDateUpdate}
          values={initialValues(cashbackParams)}
        />
      </form>
    </div>
  );
};

const CashbackEditContainer = createFragmentContainer(CashbackEditView, {
  cashback: graphql`
    fragment CashbackEdit_cashback on Cashback {
      id
      date
      place
      storeId
      rate
      amount
    }
  `,
  lists: graphql`
    fragment CashbackEdit_lists on Lists {
      stores(first: 1000, active: false) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `,
});

const CashbackEdit = () => {
  return (
    <StoreProvider
      container={CashbackEditContainer}
      modern
      query={graphql`
        query CashbackEditQuery($cashbackId: ID!) {
          cashback: cashback(id: $cashbackId) {
            ...CashbackEdit_cashback
          }
          lists {
            ...CashbackEdit_lists
          }
        }
      `}
    />
  );
};

export default withRouter(CashbackEdit);

CashbackEditView.propTypes = {
  lists: PropTypes.shape({
    stores: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: StorePresenter.shape().isRequired,
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  relay: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
  cashback: CashbackPresenter.shape().isRequired,
};
